import { StoryDateType } from './story-date-type.enum';

export class StoryDate {
  public dateType: StoryDateType;
  public year: number;
  public month: number;
  public day: number;

  constructor(data: Partial<StoryDate> = {}) {
    const now = new Date();
    this.dateType = data?.dateType ?? StoryDateType.ExactDate;
    this.year = data?.year ?? now.getFullYear();
    this.month = data?.month ?? now.getMonth() + 1; // +1 because JS months are 0-based
    this.day = data?.day ?? now.getDate();
  }

  public toString(): string | null {
    switch (this.dateType) {
      case StoryDateType.ExactDate:
        return `${this.year}-${this.month?.toString().padStart(2, '0')}-${this.day.toString().padStart(2, '0')}`;
      case StoryDateType.MonthAndYear:
        return `${this.year}-${this.month?.toString().padStart(2, '0')}`;
      case StoryDateType.Year:
        return this.year.toString();
      default:
        return null;
    }
  }

  public toTemplateString(): string {
    switch (this.dateType) {
      case StoryDateType.ExactDate:
        return `${this.day.toString().padStart(2, '0')}/${this.month?.toString().padStart(2, '0')}/${this.year}`;
      case StoryDateType.MonthAndYear:
        return `${this.month?.toString().padStart(2, '0')}/${this.year}`;
      case StoryDateType.Year:
        return this.year.toString();
      default:
        return '';
    }
  }

  public static createFromApi(data: Partial<StoryDate> = {}): StoryDate {
    return new StoryDate(data);
  }

  public static crateFromString(input: null | string = null): StoryDate {
    if (input === null || input === undefined) {
      const now = new Date();
      return new StoryDate({
        dateType: StoryDateType.Unknown,
        year: now.getFullYear(),
        month: now.getMonth() + 1,
        day: now.getDate(),
      });
    }

    // Full date: YYYY-MM-DD
    const fullDateMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(input);
    if (fullDateMatch) {
      const [, year, month, day] = fullDateMatch;
      return new StoryDate({
        dateType: StoryDateType.ExactDate,
        year: Number(year),
        month: Number(month),
        day: Number(day),
      });
    }

    // Month and year: YYYY-MM
    const monthYearMatch = /^(\d{4})-(\d{2})$/.exec(input);
    if (monthYearMatch) {
      const [, year, month] = monthYearMatch;
      return new StoryDate({
        dateType: StoryDateType.MonthAndYear,
        year: Number(year),
        month: Number(month),
      });
    }

    // Year only: YYYY
    const yearMatch = /^(\d{4})$/.exec(input);
    if (yearMatch) {
      const [, year] = yearMatch;
      return new StoryDate({
        dateType: StoryDateType.Year,
        year: Number(year),
      });
    }

    // Safe default
    return new StoryDate({
      dateType: StoryDateType.Unknown,
      year: 0,
      month: 0,
      day: 0,
    });
  }
}
